import {
  Box,
  Button,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { closeUpgradeModal } from "../features/auth/actions";
import { trackEvent } from "../shared/analytics";
import Benefits from "../features/billing/components/Benefits";
import RedwingUpgrade from "../resources/images/redwing-upgrade.png";

// const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

function UpgradeModal() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const isOpen = useSelector((state: any) => state.upgrade.isOpen);
  const isOpen = useSelector((state: any) => state.upgrade.isOpen) as boolean;

  useEffect(() => {
    if (isOpen) {
      trackEvent("paywall_viewed", { source: "upgrade_modal" });
    }
  }, [isOpen]);

  const onClose = () => {
    trackEvent("paywall_dismissed", { source: "upgrade_modal" });
    dispatch(closeUpgradeModal());
  };

  const handleSubmit = () => {
    trackEvent("upgrade_clicked", { source: "upgrade_modal" });
    dispatch(closeUpgradeModal());
    navigate("/go-premium");
  };

  return (
    <Modal onClose={onClose} isOpen={isOpen} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader p="0">
          <Image
            src={RedwingUpgrade}
            alt="Redwing - Upgrade"
            maxHeight="150px"
            w="full"
            objectFit="cover"
          />
          <Box px="6" py="3">
            Unlock Everything
          </Box>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text pb="3">Go Premium and get access to:</Text>
          <Benefits />
        </ModalBody>
        <ModalFooter>
          <Button tabIndex={6} onClick={onClose}>
            Maybe later
          </Button>
          <Button
            colorScheme="red"
            color="white"
            tabIndex={5}
            ml="3"
            onClick={handleSubmit}
          >
            Upgrade to Premium
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default UpgradeModal;
